import styled from "styled-components";

export const Message = styled.div`
  position: relative;
  .message__sender-name {
    margin: ${({ option }) =>
      option === "doctor" ? "0 0 0 auto" : "0 auto 0 0"};
    color: #68688d;
    font-family: "Nunito Sans";
    font-size: 16px;
    width: max-content;
    margin-bottom: 3px;
    min-height: 22px;
  }
  .message {
    font-size: 0.75rem;
    width: fit-content;
    max-width: 500px;
    white-space: pre-line;
    font-family: "Nunito Sans";
    font-size: 16px;
    word-wrap: break-word;
    &--patient {
      margin-left: auto;
      padding: 14.505px 10px;
      border-radius: 20px 20px 10px 20px;
      border: #1f1f52;
      background: #1f1f52;
      color: #fff;
    }
    &--reciever {
      padding: 14.505px 10px;
      border-radius: 20px 20px 20px 10px;
      border: 0.806px solid #e8e7f4;
      background: #e8e7f4;
      color: #36369b;
      margin-bottom: 15px;
    }
    a {
      text-decoration: underline;
    }
    .download-button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: #edeaff;
      border: none;
      border-radius: 14px;
      padding: 10px;
      cursor: pointer;
      color: #6c6bcc;
      font-size: 20px;
    }
    &__loading {
      /* width: 514px; */
      height: 272px;
      border-radius: 14px;
      background-color: #edeaff;
      margin-bottom: 10px;
    }
    &__img {
      cursor: pointer;
      /* width: 514px; */
      height: 272px;
      margin-bottom: 10px;
      position: relative;
      &-file {
        border-radius: 14px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__pdf {
      cursor: pointer;
      position: relative;
      margin-bottom: 10px;
      border-radius: 14px;
      /* width: 514px; */
      height: 272px;
      background-color: white;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-icon {
        width: 100%;
        margin-top: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 50px;
        color: #707582;
      }
      &-footer {
        background-color: #edeaff;
        padding: 16px 10px;
        color: #1f1f52;
        font-size: 17px;
      }
    }
  }
  .message__time {
    margin: ${({ option }) =>
      option === "doctor" ? "0 0 0 auto" : "0 auto 0 0"};
    width: max-content;
    font-family: "Nunito";
    color: #68688d;
    font-size: 14px;
    margin-bottom: 8px;
    margin-top: 5px;
  }
  .message__tail--reciever {
    position: absolute;
    bottom: 5px;
    left: -10px;
  }
  .message__tail--patient {
    position: absolute;
    bottom: -10px;
    right: -9px;
  }
`;
